import { IServiceMetadata } from "../models"
import { ServiceReqHelper } from "../helpers/helper"
import { ServiceRequestWizard } from "./ServiceRequestWizard"
import { useServiceRequestContext } from "./ServiceRequestContext"

export const NewServiceRequest = ({ submitLabel, entity, relativePath, hideHeader, hideTitle, metadata, changeStatus, onComplete }: {
    submitLabel?: string
    entity?: string,
    relativePath?: string,
    hideHeader?: boolean,
    hideTitle?: boolean,
    metadata?: IServiceMetadata,
    changeStatus?: boolean,
    onComplete: (requestId: string) => void,
}) => {
    const { result } = useServiceRequestContext()
    const { serviceRequest } = result || {}

    return <>
        {(metadata) && <>
            <ServiceRequestWizard
                submitLabel={submitLabel}
                request={serviceRequest}
                onComplete={onComplete}
                metadata={metadata}
                entity={entity}
                hideHeader={hideHeader}
                hideTitle={hideTitle}
                changeStatus={changeStatus}
                relativePath={relativePath}
                initValues={ServiceReqHelper.initValues(metadata)}
                schemas={ServiceReqHelper.schema(metadata)} />
        </>}
    </>
}
